import { render } from "./HomeFooter.vue?vue&type=template&id=3d6c6e88&scoped=true"
import script from "./HomeFooter.vue?vue&type=script&lang=js"
export * from "./HomeFooter.vue?vue&type=script&lang=js"

import "./HomeFooter.vue?vue&type=style&index=0&id=3d6c6e88&lang=less&scoped=true"

import exportComponent from "C:\\project\\digirebar\\famous-build-en\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6c6e88"]])

export default __exports__